module.exports = __webpack_public_path__ + "img/blog-gb-whatsapp-safe-to-use.dd376f0b.webp";